(() => {
  if (window.oppaSlideshowPass8) return;
  window.oppaSlideshowPass8 = true;
  const controllers = new Map();

  function mount(root) {
    if (controllers.has(root)) return;
    const slides = [...root.querySelectorAll('.oppa-hero-slide')];
    if (!slides.length) return;
    const dots = [...root.querySelectorAll('[data-dot]')];
    const wrap = root.querySelector('.oppa-hero-slideshow__slides');
    const pause = root.querySelector('[data-slideshow-pause]');
    const abort = new AbortController();
    const options = { signal: abort.signal };
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoplay = wrap?.dataset.autoplay === 'true';
    const delay = Math.max(3000, (Number(wrap?.dataset.speed) || 8) * 1000);
    let current = 0;
    let timer;
    let userPaused = false;
    let hovering = false;
    let visible = true;
    let editorSelected = false;

    function stop() {
      window.clearInterval(timer);
      timer = undefined;
    }

    function syncTimer() {
      stop();
      if (!autoplay || userPaused || hovering || !visible || editorSelected || document.hidden || motion.matches || root.contains(document.activeElement) || slides.length < 2) return;
      timer = window.setInterval(() => show(current + 1), delay);
    }

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-current', String(i === current));
      });
    }

    function go(index) {
      show(index);
      syncTimer();
    }

    root.querySelector('.oppa-hero-slideshow__nav--next')?.addEventListener('click', () => go(current + 1), options);
    root.querySelector('.oppa-hero-slideshow__nav--prev')?.addEventListener('click', () => go(current - 1), options);
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i), options));
    root.querySelector('.oppa-hero-slideshow__controls')?.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      go(current + (event.key === 'ArrowRight' ? 1 : -1));
      dots[current]?.focus();
    }, options);

    if (pause) {
      pause.hidden = !autoplay || slides.length < 2;
      pause.addEventListener('click', () => {
        userPaused = !userPaused;
        pause.setAttribute('aria-pressed', String(userPaused));
        pause.setAttribute('aria-label', userPaused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
        pause.textContent = userPaused ? '▶' : 'Ⅱ';
        syncTimer();
      }, options);
    }

    root.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse') return;
      hovering = true;
      stop();
    }, options);
    root.addEventListener('pointerleave', () => { hovering = false; syncTimer(); }, options);
    root.addEventListener('focusin', stop, options);
    root.addEventListener('focusout', () => window.queueMicrotask(syncTimer), options);
    document.addEventListener('visibilitychange', syncTimer, options);
    motion.addEventListener('change', syncTimer, options);
    const observer = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      syncTimer();
    });
    observer.observe(root);

    root.addEventListener('shopify:block:select', (event) => {
      const selected = event.target.closest('.oppa-hero-slide');
      if (!selected) return;
      editorSelected = true;
      show(slides.indexOf(selected));
      stop();
    }, options);
    root.addEventListener('shopify:block:deselect', () => { editorSelected = false; syncTimer(); }, options);

    show(0);
    syncTimer();
    controllers.set(root, () => {
      stop();
      observer.disconnect();
      abort.abort();
      controllers.delete(root);
    });
  }

  function scan(container) {
    if (container.matches?.('[data-oppa-slideshow]')) mount(container);
    container.querySelectorAll('[data-oppa-slideshow]').forEach(mount);
  }

  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [root, destroy] of controllers) {
      if (event.target === root || event.target.contains(root)) destroy();
    }
  });
})();
